export const splitLangPrefix = (language: string): string => {
  if (language && language.includes('-')) return language.split('-')[0];
  return language;
};
